export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function monthLabel(month) {
  const index = Number(month) - 1;
  return MONTH_NAMES[index] || "—";
}

export function monthYearLabel(month, year) {
  if (!month || !year) return "—";
  return `${monthLabel(month)} ${year}`;
}

export function childName(child) {
  if (!child) return "—";
  const name = `${child.firstName || ""} ${child.lastName || ""}`.trim();
  return name || "—";
}

export function formatAmount(amount) {
  if (amount === null || amount === undefined || amount === "") return "—";
  const value = Number(amount);
  if (Number.isNaN(value)) return String(amount);
  return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function paidLabel(isPaid) {
  return isPaid ? "Paid" : "Unpaid";
}

export function paidTone(isPaid) {
  return isPaid ? "is-active" : "is-inactive";
}

export const FEE_STATUSES = [
  { value: "UNPAID", label: "Unpaid" },
  { value: "OVERDUE", label: "Overdue" },
  { value: "PROOF_SUBMITTED", label: "Proof waiting" },
  { value: "REJECTED", label: "Rejected" },
  { value: "PAID", label: "Paid" },
  { value: "WAIVED", label: "Waived" },
  { value: "CANCELLED", label: "Cancelled" },
];

export function voucherStatus(fee) {
  if (fee?.displayStatus) return fee.displayStatus;
  if (fee?.status) return fee.status;
  return fee?.isPaid ? "PAID" : "UNPAID";
}

export function statusLabel(status) {
  return FEE_STATUSES.find((item) => item.value === status)?.label || "Unpaid";
}

export function statusTone(status) {
  if (status === "PAID" || status === "WAIVED") return "is-paid";
  if (status === "OVERDUE" || status === "REJECTED") return "is-alert";
  if (status === "PROOF_SUBMITTED") return "is-wait";
  if (status === "CANCELLED") return "is-muted";
  return "is-open";
}

export function voucherTotal(fee) {
  if (fee?.totalAmount !== undefined && fee?.totalAmount !== null && fee?.totalAmount !== "") {
    return fee.totalAmount;
  }
  return fee?.amount;
}

export function canEditVoucher(fee) {
  return !["PAID", "WAIVED", "CANCELLED"].includes(voucherStatus(fee));
}

export function formatReceiptNo(receiptNo) {
  if (!receiptNo) return "—";
  return String(receiptNo).trim().toUpperCase();
}

function padSequence(digits) {
  const numeric = String(digits || "").replace(/\D/g, "");
  if (!numeric) return "00000";
  return numeric.slice(-5).padStart(5, "0");
}

export function receiptNoParts(receiptNo) {
  const full = formatReceiptNo(receiptNo);
  if (full === "—") return { full, isStructured: false, prefix: "FEE", sequence: "" };

  const compact = full.match(/^([A-Z]{3})(\d+)$/);
  if (compact) {
    return {
      full,
      isStructured: true,
      prefix: compact[1],
      sequence: padSequence(compact[2]),
    };
  }

  const current = full.match(/^BW-FEE-\d{6}-(\d+)$/i);
  if (current) {
    return { full, isStructured: true, prefix: "FEE", sequence: padSequence(current[1]) };
  }

  const legacy = full.match(/^BW-\d{4}-\d{2}-(\d+)$/i);
  if (legacy) {
    return { full, isStructured: true, prefix: "FEE", sequence: padSequence(legacy[1]) };
  }

  const trailing = full.match(/(\d+)$/);
  if (trailing) {
    return { full, isStructured: true, prefix: "FEE", sequence: padSequence(trailing[1]) };
  }

  return { full, isStructured: false, prefix: "FEE", sequence: "" };
}

export function receiptNoDisplay(receiptNo) {
  const parts = receiptNoParts(receiptNo);
  if (parts.full === "—") return "—";
  if (!parts.sequence) return parts.full;
  return `${parts.prefix}${parts.sequence}`;
}
